import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { LocalStorageKeys } from '../../../shared/model/local-storage-data/localStorageKeys';
import { AuthSelectors } from '../../../shared/store/auth/auth.selectors';
import { LocalStorageUtil } from '../../../shared/util/local-storage.util';

@Injectable({ providedIn: 'root' })
export class MainLogicService {
  private store: Store = inject(Store);
  public isAfterWelcomeScreen(): Observable<boolean> {
    return of(
      !!LocalStorageUtil.getFromStorage(LocalStorageKeys.FORM_OWNER_NAME) &&
        !!LocalStorageUtil.getFromStorage(LocalStorageKeys.FORM_OWNER_TYPE)
    );
  }

  public isDashboardBannerVisible(): Observable<boolean> {
    return of(
      !LocalStorageUtil.getFromStorage(LocalStorageKeys.BANNER_HIDDEN) &&
        !this.store.selectSnapshot(AuthSelectors.getCurrentLogged)
    );
  }
}
